import { translate } from "app/filters/i18nFilter";
import { Body } from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/Body";
import { Footer } from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/Footer";
import { Title, Container } from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/Styled";
import type { FC } from "react";
import type { SegmentsModalProps } from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/types";

export const Wizard: FC<SegmentsModalProps> = (props) => {
    const { footerProps, bodyProps } = props;

    return (
        <Container>
            <Title>{translate("segments.popup.wizard.title")}</Title>
            <Body {...bodyProps} />
            <Footer {...footerProps} />
        </Container>
    );
};
